module.exports = __webpack_public_path__ + "img/pMaya.16c45a0c.svg";